import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepButton from '@material-ui/core/StepButton';
import logo from '../assets/logo_only_white.svg';
import BookWhiteIcon from '../assets/icons/book_white.png';
import StoreWhiteIcon from '../assets/icons/store_white.png';
import MountainWhiteIcon from '../assets/icons/mountain_white.png';
import StepConnector from '@material-ui/core/StepConnector';
import LayersIcon from '@material-ui/icons/Layers';
import TelegramIcon from '@material-ui/icons/Telegram';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';


const CustomStepConnector = withStyles({
    alternativeLabel: {
        top: 18,
    },
    active: {
        '& $line': {
            backgroundImage: 'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 85%, #00d084 100%)',
        },
    },
    completed: {
        '& $line': {
            backgroundImage: 'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);

const useCustomStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 40,
        height: 40,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        backgroundImage: 'linear-gradient(108deg, #00D084 7.97%, #0693E3 53.17%, #0047FF 91.42%); !important!important',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
        backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    },
});


function CustomStepIcon(props) {
    const classes = useCustomStepIconStyles();
    const {active, completed} = props;

    const icons = {
        1: <img src={BookWhiteIcon} height="24" alt="book" />,
        2: <img src={MountainWhiteIcon} height="32" alt="mountain" />,
        3: <DirectionsRunIcon />,
        4: <img src={StoreWhiteIcon} height="24" alt="store" />,
        5: <LayersIcon />,
        6: <TelegramIcon />,
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        background: '#2f3135',
        boxShadow: "0px 4px 4px #000000",
        '& > img': {
            width: 50,
            height: 50,
            margin: 8,
            marginLeft: 32,
        },
        '& .MuiStepper-root': {
            flex: '1',
            background: 'inherit',
            padding: theme.spacing(2),
            '& .MuiStepLabel-label': {
                marginTop: 8,
            }
        },
    },
    red: {
        '& .MuiStepLabel-iconContainer > div': {
            backgroundImage: 'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
        }
    },
    current: {
        '& .MuiStepLabel-iconContainer > div': {
            backgroundImage: 'linear-gradient(108deg, #00D084 7.97%, #0693E3 53.17%, #0047FF 91.42%); !important!important',
        }
    },
}));



export default function HeaderBar({activeStep, setActiveStep, completedSteps}) {
    const classes = useStyles();
    const steps = ['Guidelines', 'Logo', 'Activities', 'Branches', 'Overview', 'Submit']

    return (
        <div className={classes.root}>
            <img src={logo} alt="mazingday logo" className={classes.logo} />
            <Stepper alternativeLabel activeStep={activeStep} connector={<CustomStepConnector />}>
                {steps.map((label, i) => (
                    <Step key={label} style={{cursor: 'pointer'}} className={clsx({[classes.red]: completedSteps.includes(i), [classes.current]: activeStep === i})}>
                        <StepButton
                            onClick={() => setActiveStep(i)}
                            disabled={completedSteps.indexOf(i) === -1}>
                            <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
        </div>
    );
}
